import type { LayoutChangeEvent } from "react-native";

import { Space } from "~/constants/sizing";

export type LayoutEventHandler = (event: LayoutChangeEvent) => void;

export const setWidthOnLayout = (
    setWidth: (width: number) => void,
    then?: LayoutEventHandler | undefined,
): LayoutEventHandler => {
    return (event: LayoutChangeEvent) => {
        setWidth(event.nativeEvent.layout.width);
        then?.(event);
    };
};
export const setHeightOnLayout = (
    setHeight: (height: number) => void,
    then?: LayoutEventHandler | undefined,
): LayoutEventHandler => {
    return (event: LayoutChangeEvent) => {
        setHeight(event.nativeEvent.layout.height);
        then?.(event);
    };
};

export const setDimensionsOnLayout = (
    setDimensions: (dimensions: { width: number; height: number }) => void,
    then?: LayoutEventHandler | undefined,
): LayoutEventHandler => {
    return (event: LayoutChangeEvent) => {
        const { width, height } = event.nativeEvent.layout;
        setDimensions({ width, height });
        then?.(event);
    };
};

export const itemWidth = (width: number, cols = 1, gap = Space.sm): number => {
    const total_width = Math.max(0, width);
    const columns = Math.max(1, cols);
    const column_gap = Math.max(0, gap);

    return (total_width - (columns - 1) * column_gap) / columns;
};

export const titleWidth = (
    width: number,
    gap: number,
    left?: number | null,
    right?: number | null,
): { center: number; sides: number } => {
    const total_width = Math.max(0, width);
    const left_width = Math.max(0, left ?? 0);
    const right_width = Math.max(0, right ?? 0);
    const largest_width = Math.max(left_width, right_width);
    const column_gap = Math.max(0, largest_width ? gap : 0);

    return {
        center: Math.max(0, total_width - (column_gap + largest_width) * 2),
        sides: largest_width,
    };
};
